<template>
  <!-- prettier-ignore -->
  <div class="advice">
    <price-widget-tab-content
      v-for="tabContent in tabContentEntries"
      :key="tabContent.componentKey"
      :tab-content="tabContent"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'

import PriceWidgetTabContent from './PriceWidgetTabContent.vue'
import FabAlva from '@/assets/fab/alva.jpeg'
import CustomerAssistant from '@/assets/Kundenberatung.jpg'

import { useBasket, useCollective, usePartner } from '@/hooks'

import { COLLECTIVE_CHANNEL } from '@/config/constants'

const { basket } = useBasket()
const { collective } = useCollective()
const { partner } = usePartner()

const imageAlva = FabAlva
const imageAssistant = CustomerAssistant

// Computed
const hideAide = computed(() => {
  return (
    collective?.channel === COLLECTIVE_CHANNEL.SCPC ||
    basket.existingCustomer ||
    partner.value.isBroker ||
    partner.value.isMobileDistributor
  )
})

const tabContentEntries = computed(() => {
  let entries = []
  if (!hideAide.value) {
    entries.push({
      componentKey: 'aide',
      image: imageAlva,
    })
  }
  if (!basket.existingCustomer) {
    entries.push({
      componentKey: 'assistant',
      image: imageAssistant,
    })
  }
  return entries
})
</script>
